import React, { Component } from 'react'
import { checkTranslation, translate } from '../../utils/useful'

import IntractionActionsList from '../IntractionActionsList'
import importedIcons from '../inputs/icons'


export default class RecordToolbar extends Component {

    state = {
        actions: {

            edit: { key: "edit", label: '{{lang}}Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.edit },
            share: { key: "share", label: '{{lang}}Share', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.activityLog },
            print: { key: "print", label: '{{lang}}Print', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.archive },


        }
    }

    componentDidMount() {
        // console.log("componentDidMount !!!!!")
    }

    componentDidUpdate = (prevProps) => {
        // if (prevProps.data != this.props.data) { }
    }

    render() {

        let colors = this.props.colors
        return (
            <div className='w-100 flexc '>

                {Object.values(this.state.actions).map((item, index) => {
                    return (
                        <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='mrd-2 flexcc dark-blur-hover px-2 py-0 br-5'>
                            <div className={'flexcc  py-1' }>
                                <div className='flexcc mrd-1'>
                                    <img className={colors?.iconInvert ? '' : 'invert'} width={18} src={item.icon} />
                                </div>
                                <p className='font-size-13 ' style={{ color: colors.textColor }}>{ translate(item.label)}</p>
                            </div>
                        </button>

                    )
                })}


            </div>
        )
    }
}
